function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "7935ec95c421cee6d86eb22ecd13295e"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M106.669,52.438c0,0,102.123-55.525,189.491,11.392l-48.896,167.995 c0,0-54.756-37.67-95.361-33.602c-40.605,4.079-94.13,23.508-94.13,23.508L106.669,52.438z M0.5,420.566 c22.54-11.653,56.372-17.559,95.35-20.823c39.011-3.255,93.91,32.468,93.91,32.468l49.401-169.776 c-7.817-5.618-44.168-30.094-89.666-33.348c-45.52-3.255-100.354,22.243-100.354,22.243L0.5,420.566z M216.104,447.165 c8.928,3.519,38.22,31.38,86.972,33.854c48.763,2.419,102.541-22.749,102.541-22.749s47.894-167.6,48.861-168.249 c0.33-0.176-0.604,0.484-0.968,0.649c-45.596,17.845-68.872,20.506-102.496,21.309c-34.141,0.824-86.269-33.095-86.269-33.095 L216.104,447.165z M322.01,81.575l-48.995,167.017c0,0,39.803,39,95.867,35.768c56.098-3.267,86.532-20.945,93.976-23.442 L511.5,92.416c0,0-64.606,26.982-106.851,22.09C362.384,109.613,336.094,91.657,322.01,81.575z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.e8a53a32ebfe6a703c2493eab0f2746c.svg";
export { ForwardRef as ReactComponent };